/**
 * Fred Olsen Cruise Lines Dynamica LTT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AutoConfirmConfig { 
    productId: string;
    isAutoPilot?: boolean;
    minPriceChange?: number;
    maxPriceChange?: number;
}

